import { IGetEntregaObrasClienteArquivoByIdUseCase } from "../../../presentation/useCases/read/get_entrega_obras_cliente_arquivo_by_id_use_case";
import { EntregaObraClienteArquivoModel } from "../../models/entrega_obra_cliente_arquivo";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * GetEntregaObrasClienteArquivoByIdUseCase
 */

export class GetEntregaObrasClienteArquivoByIdUseCase implements IGetEntregaObrasClienteArquivoByIdUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async execute(idEntregaObraClienteArquivo: number): Promise<EntregaObraClienteArquivoModel> {
    return await this.repository.getEntregaObrasClienteArquivo(idEntregaObraClienteArquivo);
  }

}
